import { useEffect, useState, useCallback } from "react";
import FAQList from "../../components/FAQList/FAQList.tsx";
import FAQFilter from "../../components/FAQFilter/FAQFilter.tsx";
import { NavLink } from "react-router-dom";
import "./FAQPage.css";
import { IFAQAll } from "@/types/SPTypes.tsx";
import { useAppSelector } from "@/hooks/storeHooks.ts";
import { ButtonComponent, FrameComponent } from "fmv-component-ui-library";
import { FrameColor, Variant } from "@/utils/enums.ts";

const FAQPage = () => {
  const [filteredFAQs, setFilteredFAQs] = useState<IFAQAll[]>([]);
  const [fullScreen, setFullScreen] = useState(false);
  const FAQData = useAppSelector(state => state.application.FAQs);

  // Scroll to top button
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Add a scroll event listener to detect if the user has scrolled down
    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      setIsVisible(scrollTop > 0);
    };
    window.addEventListener("scroll", handleScroll);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = (event: { preventDefault: () => void }) => {
    event.preventDefault(); // Prevent website reload & form onSubmit activation.
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  const handleFAQFilterChange = useCallback((updatedFAQs: IFAQAll[]) => {
    setFilteredFAQs(updatedFAQs);
  }, []);

  return (
    <>
      <FrameComponent color={FrameColor.BLUE} headerAlign="left" header="FAQs">
        <div
          style={{ display: isVisible ? "block" : "none" }}
          className="scroll-to-top-btn"
        >
          <ButtonComponent
            onClick={scrollToTop}
            variant={Variant.SECONDARY}
            label=" Tillbaka till start"
          />
        </div>
        <div className="page-container">
          <div className="info-text-container">
            <h2>
              Använd filtren nedan eller sök för att snabbt hitta svar på
              vanliga frågor. Om du inte hittar det du söker -{" "}
              <NavLink to="/skapa-arende">
                <b>klicka här</b>
              </NavLink>{" "}
              eller på "Gå till skapa ärende" längst ner för att kontakta oss
              direkt.
            </h2>
          </div>
          <div>
            {!fullScreen && (
              <div className="FAQ-filter">
                <FAQFilter
                  FAQData={FAQData}
                  handleFAQFilterChange={handleFAQFilterChange}
                />
              </div>
            )}
            <div>
              <ButtonComponent
                onClick={() => setFullScreen(!fullScreen)}
                variant={Variant.SUCCESS}
                size="1.25rem"
                label={
                  fullScreen
                    ? "Avsluta visning av FAQ svar i fullskärmsläge"
                    : "Visa FAQ svar i fullskärmsläge"
                }
              />
              <FAQList FAQData={filteredFAQs} />
            </div>
          </div>
        </div>
      </FrameComponent>
    </>
  );
};
export default FAQPage;
